import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@groot/ui/select";
import { ArrowDownUp } from "lucide-react";

interface TransactionSortSelectorProps {
  value: "asc" | "desc";
  onValueChange: (value: "asc" | "desc") => void;
}

export function TransactionSortSelector({ value, onValueChange }: TransactionSortSelectorProps) {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className="h-7 text-xs w-auto gap-1.5 px-2 border-input bg-background hover:bg-accent hover:text-accent-foreground">
        <ArrowDownUp className="size-3.5" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="desc" className="text-xs">
          Newest first
        </SelectItem>
        <SelectItem value="asc" className="text-xs">
          Oldest first
        </SelectItem>
      </SelectContent>
    </Select>
  );
}
